import React, { useState } from 'react'
import { Header, Label, Divider, Grid, Segment, Icon, Table, Image } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import ShowMore from 'react-show-more-button/dist/module';
import "./RealstateFurtherInformation.css"


const RealstateFurtherInformation = () => {
    const { t } = useTranslation();

    return (<div className="RealstateFurtherInformation m-3-b m-3-t">
        <Header as='h3' className="d-flex flex-row align-items-end">
            {t("property:FurtherInformation")}
        </Header>
        <ShowMore
            classNameButton="ui button blue"
            maxHeight={450}>
            <Table >
                <Table.Header>
                    <Table.Row >
                        <Table.HeaderCell colSpan="1">
                            <Header as='h4' className="d-flex flex-row align-items-end">
                                <Icon name="home" color="teal" />
                                {t("property:PropertyInformation")}
                            </Header>
                        </Table.HeaderCell>

                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>
                            <Grid>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:YearBuilt")} :   <span className="m-05-r m-05-l">۱۴۰۰</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Type")} :   <span className="m-05-r m-05-l">ویلا</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Status")} :   <span className="m-05-r m-05-l">فروشی</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:NumberOfFloors")} :   <span className="m-05-r m-05-l">۳ طبقه</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:NumberOfUnits")} :   <span className="m-05-r m-05-l">۹ واحد</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Description")} :   <span className="m-05-r m-05-l">توضیحات در مورد واحد</span>
                                    </Label>
                                </Grid.Column>
                            </Grid>
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
            <Table >
                <Table.Header>
                    <Table.Row >
                        <Table.HeaderCell colSpan="1">
                            <Header as='h4' className="d-flex flex-row align-items-end">
                                <Icon name="bed" color="teal" />
                                {t("property:InteriorFeatures")}
                            </Header>
                        </Table.HeaderCell>

                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>
                            <Grid>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Package")} :   <span className="m-05-r m-05-l">دارد</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Radiator")} :   <span className="m-05-r m-05-l">دارد</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Cooler")} :   <span className="m-05-r m-05-l">دارد</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Chiller")} :   <span className="m-05-r m-05-l">دارد</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:AirConditioner")} :   <span className="m-05-r m-05-l">دارد</span>
                                    </Label>
                                </Grid.Column>

                            </Grid>
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
            <Table >
                <Table.Header>
                    <Table.Row >
                        <Table.HeaderCell colSpan="1">
                            <Header as='h4' className="d-flex flex-row align-items-end">
                                <Icon name="tree" color="teal" />
                                {t("property:OtherFeatures")}
                            </Header>
                        </Table.HeaderCell>

                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>
                            <Grid>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Elevator")} :   <span className="m-05-r m-05-l">دارد</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Pool")} :   <span className="m-05-r m-05-l">دارد</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Sauna")} :   <span className="m-05-r m-05-l">دارد</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Jacuzzi")} :   <span className="m-05-r m-05-l">دارد</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Underground")} :   <span className="m-05-r m-05-l">دارد</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Yard")} :   <span className="m-05-r m-05-l">دارد</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Backyard")} :   <span className="m-05-r m-05-l">دارد</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:Patio")} :   <span className="m-05-r m-05-l">دارد</span>
                                    </Label>
                                </Grid.Column>
                            </Grid>
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
            <Table >
                <Table.Header>
                    <Table.Row >
                        <Table.HeaderCell colSpan="1">
                            <Header as='h4' className="d-flex flex-row align-items-end">
                                <Icon name="tag" color="teal" />
                                {t("property:Price&Status")}
                            </Header>
                        </Table.HeaderCell>

                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    <Table.Row>

                        <Table.Cell>
                            <Grid>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:LandArea")} :   <span className="m-05-r m-05-l">۸۶۰ متر مربع</span>
                                    </Label>
                                </Grid.Column>
                                
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:TotalPrice")} :   <span className="m-05-r m-05-l">۰ تومان</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:PricePerMeter")} :   <span className="m-05-r m-05-l">۰ تومان</span>
                                    </Label>
                                </Grid.Column>
                                <Grid.Column computer={3} mobile={16} className="p-05">
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        <Icon size="tiny" name="circle" />
                                        {t("property:PriceDescription")} :   <span className="m-05-r m-05-l">توضیحات اضافی</span>
                                    </Label>
                                </Grid.Column>

                            </Grid>
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </ShowMore>
    </div>
    )
}
export default RealstateFurtherInformation